import { BasicService } from "./core/basic.service";

export class ManufacturerService extends BasicService {

  static getList(data = {}) {
    return this.http.post('/manufacturer/manufacturerList', data);
  }

  static selectList() {
    return this.http.post('/manufacturer/manufacturerList').then(data => {
      data.forEach(item => {
        item.label = item.name;
        item.value = item.id.toString();
      });
      return data;
    });
  }

  static deleteItem(ids) {
    return this.http.post('/manufacturer/manufacturerDel', { ids });
  }

  static save(data) {
    return this.http.post('/manufacturer/manufacturerSave', data);
  }
}